import { navLinks, whatsappLink, whatsappMessages } from '@/lib/site-data'
import {Instagram, Menu, X} from 'lucide-react'
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

function Header() {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  return (
    <header className="sticky top-0 z-40 border-b border-white/5 bg-[#0B0919]/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2 text-lg font-bold text-white" onClick={() => setIsOpen(false)}>
          <Instagram className="h-5 w-5 text-[#8B5CF6]" />
          Muita Mídia
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.to
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors ${
                  isActive ? 'text-white' : 'text-zinc-400 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            )
          })}
        </nav>

        <a
          href={whatsappLink(whatsappMessages.headerCta)}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden rounded-full bg-[#8B5CF6] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#7C3AED] lg:inline-flex"
        >
          Falar no WhatsApp
        </a>

        <button
          type="button"
          onClick={() => setIsOpen(prev => !prev)}
          aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
          className="inline-flex items-center justify-center rounded-lg p-2 text-white lg:hidden"
        >
          {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {isOpen ? (
        <nav className="border-t border-white/5 bg-[#0B0919] px-6 py-4 lg:hidden">
          <ul className="flex flex-col gap-4">
            {navLinks.map(link => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  onClick={() => setIsOpen(false)}
                  className={`block text-sm font-medium ${
                    location.pathname === link.to ? 'text-white' : 'text-zinc-400'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href={whatsappLink(whatsappMessages.headerCta)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-full items-center justify-center rounded-full bg-[#8B5CF6] px-5 py-2.5 text-sm font-semibold text-white"
              >
                Falar no WhatsApp
              </a>
            </li>
          </ul>
        </nav>
      ) : null}
    </header>
  )
}

export default Header
